// extracted by mini-css-extract-plugin
module.exports = {"withoutDialog":"_31qFZ","withDialog":"_33gvP"};